import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { customPriorityBadgeColor } from "@utils/customPriorityBadgeColor";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  ticketDropdown: any,
) => {
  const { ticketTypes, categories, priorities } = ticketDropdown;

  return [
    {
      id: 0,
      key: "id",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.ID"),
      render: (id: string) => <Text color="subtitle2">{id}</Text>,
    },
    {
      id: 1,
      key: "subject",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.SUBJECT"),
      render: (subject: string) => <Text color="subtitle2">{subject}</Text>,
    },
    {
      id: 2,
      key: "category",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.CATEGORY"),
      render: (categoryId: string) => (
        <Text color="subtitle2">
          {categories?.find((item: any) => item.id === categoryId)?.name}
        </Text>
      ),
    },
    {
      id: 3,
      key: "type",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.TYPE"),
      render: (typeId: string) => (
        <Text color="subtitle2">
          {ticketTypes?.find((item: any) => item.id === typeId)?.name}
        </Text>
      ),
    },
    {
      id: 4,
      key: "priority",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.PRIORITY"),
      render: (priorityId: number) => (
        <StatusBadge
          status={priorities?.find((item: any) => item.id === priorityId)?.name}
          style={customPriorityBadgeColor(priorities, priorityId)}
        />
      ),
    },
    {
      id: 5,
      key: "status",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 6,
      key: "createdAt",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.DATE_CREATED"),
      render: (date: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {date}
        </Text>
      ),
    },
    {
      id: 7,
      key: "assignedTo",
      name: t("TICKETS.TICKET_LIST.TABLE.COLUMN.ASSIGN_PERSON"),
      render: (assignedTo: EmployeeCommonInfoType) => {
        return assignedTo ? <ProfileInfoCard employee={assignedTo} /> : <></>;
      },
    },
    {
      id: 8,
      key: "id",
      name: "",
      render: (id: number) => <ViewButton link={`${id}`} />,
    },
  ];
};
